/**
 * Mercado Pago Utility Bridge
 * 
 * Since this is a frontend-only implementation, we provide a way to
 * generate payment URLs or redirect to pre-configured checkouts.
 */

// Configuration for common plans
// Configuração dos links de pagamento do Mercado Pago
// Você deve criar esses links no painel do Mercado Pago -> Botões e Links de Pagamento
// Configuração dos links de pagamento do Mercado Pago
// Você deve criar esses planos de "Assinatura" no painel do Mercado Pago
export const MERCADO_PAGO_CONFIG = {
    plans: {
        profissional: {
            title: 'Assinatura Barbearia - Plano Profissional',
            basePrice: 120.00,
            onboarding: { // Links com 7 dias grátis
                1: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=ee70b9c453504cff97c900acad38dffd',
                3: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=ac3f2c20e4dc4f1f9c99f20335fdebaa',
                6: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=c89f6297006a48b09d92007612b6eea6',
                12: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=b38d186b110d4b8ab8c154e4d6880f12'
            },
            renewal: { // Links SEM 7 dias grátis (Dono já é cliente)
                1: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=5a913a04301d44b4ad94414c3746a106', // placeholder
                3: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=fbab89812dac493597ab0aeedbcdcc2b', // placeholder
                6: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=ad8d7dcaa1704f2aaab0fab5be6f2737', // placeholder
                12: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=af543a8bfc4a42b4a7273930ba79371a' // placeholder
            }
        }
    },
    supportWhatsapp: '5534997354131'
};

/**
 * Gets the payment link for a specific tenant and plan
 * @param {string} planId - 'profissional'
 * @param {string} tenantId - The unique ID of the barbershop
 * @param {number} cycleMonths - 1 | 3 | 6 | 12
 * @param {string} type - 'onboarding' | 'renewal'
 * @returns {string} The formatted Mercado Pago URL
 */
export const getPaymentLink = (planId, tenantId, cycleMonths = 1, type = 'onboarding') => {
    const plan = MERCADO_PAGO_CONFIG.plans[planId] || MERCADO_PAGO_CONFIG.plans.profissional;
    const links = plan[type] || plan.onboarding;
    const link = links[cycleMonths] || links[1];

    if (!link || link.includes('YOUR_')) {
        const message = encodeURIComponent(`Olá! Quero ativar meu plano ${plan.title} (Ciclo ${cycleMonths} meses) para o ID: ${tenantId}.`);
        return `https://wa.me/${MERCADO_PAGO_CONFIG.supportWhatsapp}?text=${message}`;
    }

    // Adiciona o external_reference para o Webhook identificar a loja e o plano (meses)
    const separator = link.includes('?') ? '&' : '?';
    return `${link}${separator}external_reference=${tenantId}|${cycleMonths}`;
};
